export default "__VITE_ASSET__9160cbbf__"